/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_OutputInputs */

const en_landing_why_output = /** @type {(inputs: Landing_Why_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Output`)
};

const zh_landing_why_output = /** @type {(inputs: Landing_Why_OutputInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`输出`)
};

/**
* | output |
* | --- |
* | "Output" |
*
* @param {Landing_Why_OutputInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_output = /** @type {((inputs?: Landing_Why_OutputInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_OutputInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_output(inputs)
	return zh_landing_why_output(inputs)
});
export { landing_why_output as "landing.why.output" }